export default "__VITE_ASSET__ZZKEP7_1__"